import { render, staticRenderFns } from "./Comprasfiliais.vue?vue&type=template&id=b68ada1a&"
import script from "./Comprasfiliais.vue?vue&type=script&lang=js&"
export * from "./Comprasfiliais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports